import { render, staticRenderFns } from "./BlacklistHeader.vue?vue&type=template&id=5eafd3b1&scoped=true"
import script from "./BlacklistHeader.vue?vue&type=script&lang=js"
export * from "./BlacklistHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eafd3b1",
  null
  
)

export default component.exports